import { AxiosPriorityQueue } from '../utils/api';

// The single queue every S3 PUT in the app goes through.
//
// It lives in its own module so both story-media/api.js (the low level transport)
// and story-media/upload-medium.js (the helper everything should call) can share
// one instance without importing each other.
//
// Concurrency is deliberately still 1. Raising it is a real improvement for
// throughput -- a batch of N files currently takes N sequential round trips when
// the browser would happily run six -- but it is NOT what makes uploads fail:
// stall rate by position within a batch is flat, so the queue is not cutting
// batches off at the tail. Changing it is a separate, independently reviewable
// change. See docs/upload_reliability_analysis.md in the API repo.
export const UPLOAD_CONCURRENCY = 1;

export const uploadQueue = new AxiosPriorityQueue(UPLOAD_CONCURRENCY);
